<nz-row style="flex-wrap: nowrap; position:relative; width: 100%;">
  <input nz-input #inputElement [placeholder]="placeholder" [(ngModel)]="code" (ngModelChange)="valueChanged()"/>
  @if (showBarcodeScanner) {
    <button
      nz-button
      nzType="primary"
      class="open-scanner-btn"
      (click)="createBarcodeScannerModal()"
      >
      <i
        nz-icon
        nzType="barcode"
        nzTheme="outline"
        nz-tooltip
        nzTooltipTitle="Barcode-Scanner anzeigen"
      ></i>
    </button>
  }
</nz-row>
